import { render, staticRenderFns } from "./NR.vue?vue&type=template&id=5cf8b39e&scoped=true&"
var script = {}
import style0 from "./NR.vue?vue&type=style&index=0&id=5cf8b39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf8b39e",
  null
  
)

export default component.exports